import { render, staticRenderFns } from "./AddressBookActionLayout.vue?vue&type=template&id=698c2925&scoped=true&"
import script from "./AddressBookActionLayout.vue?vue&type=script&lang=js&"
export * from "./AddressBookActionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698c2925",
  null
  
)

export default component.exports